<div class="premium-modal-wrapper">
    <ion-header class="ion-no-border premium-header">
        <div class="header-curve"></div>
        <div class="custom-toolbar">
            <div class="toolbar-content">
                <div class="icon-btn" (click)="close()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div class="title-group">
                    <div class="title-main">Seguimiento Global</div>
                    <div class="title-sub" *ngIf="trabajo">Trabajo #{{ trabajo?.id }} • {{ trabajo?.lugar }}</div>
                    <div class="title-sub" *ngIf="cotizacion && !trabajo">Cotización #{{ cotizacion?.id }} • {{
                        cotizacion?.cliente }}</div>
                </div>
            </div>
        </div>
    </ion-header>

    <ion-content class="content-bg" [fullscreen]="false">
        <div class="loading-container" *ngIf="isLoading">
            <ion-spinner name="bubbles" color="primary"></ion-spinner>
            <p>Cargando historial...</p>
        </div>

        <div class="timeline-container ion-padding" *ngIf="!isLoading">

            <div class="empty-state" *ngIf="events.length === 0">
                <ion-icon name="analytics-outline"></ion-icon>
                <h3>Sin registros aún</h3>
                <p>No se encontraron eventos registrados para este trabajo.</p>
            </div>

            <div class="timeline" *ngIf="events.length > 0">
                <div class="timeline-item" *ngFor="let event of events; let i = index"
                    [class.last]="i === events.length - 1">

                    <div class="timeline-dot-container">
                        <div class="timeline-line" *ngIf="i !== events.length - 1"></div>
                        <div class="timeline-dot" [class]="'bg-' + event.color">
                            <ion-icon [name]="event.icon"></ion-icon>
                        </div>
                    </div>

                    <div class="timeline-content">
                        <div class="event-header">
                            <span class="event-date">{{ event.date | date:'dd MMM, yyyy' }}</span>
                            <span class="event-time"
                                *ngIf="event.type === 'creation' || event.date.getHours() !== 0 || event.date.getMinutes() !== 0">
                                {{ event.date | date:'HH:mm' }}
                            </span>
                        </div>
                        <h4 class="event-title">{{ event.title }}</h4>
                        <p class="event-desc">{{ event.description }}</p>
                    </div>
                </div>
            </div>

        </div>

    </ion-content>
</div>
